import * as React from 'react';
import styles from './DateDisplay.module.css';

interface DateDisplayProps {
  day: string;
  date: string;
}

export const DateDisplay: React.FC<DateDisplayProps> = ({ day, date }) => {
  return (
    <div className={styles.dateContainer}>
      <div className={styles.dayText}>{day}</div>
      <div className={styles.dateText}>{date}</div>
    </div>
  );
};
